<li class="nav-item dropdown" dropdown>
  <a dropdownToggle type="button" data-id-cypress="notification" class="nav-link dropdown-toggle waves-light pr-2" mdbWavesEffect>
    <mdb-icon fas class="grey-text" size="lg" icon="bell"></mdb-icon>
    <span class="count" *ngIf="pagination?.nbItems! > 0"> {{ pagination?.nbItems }}</span>
  </a>
  <div class="dropdown-menu dropdown-menu-right p-0 panel" role="menu" [class.border-0]="notifications && !notifications.length">
    <a class="dropdown-item waves-light item bg-transparent p-0" @animationWhenDeleteNotification mdbWavesEffect *ngFor="let notif of notifications; let last = last">
      <div (click)="getRedirect(notif)" class="d-flex flex-row align-items-stretch mt-2">
        <i class="grey-text {{ notif.level.icon }} mx-3 {{ notif.level.color }} fa-2x align-self-center" size="lg"></i>

        <div class="d-flex flex-column flex-grow-1">
          <span class="bold title mb-1" [translate]="'notification.title.' + notif.key"></span>
          <span class="white-space" [translate]="'notification.key.' + notif.key" [translateParams]="notif.messageParams"> </span>
          <span class="d-block my-2 text-black-50 fs-5 timeline mb-0">{{ notif.createdDate | notificationTimeLine }}</span>
        </div>
        <div class="d-flex flex-column flex-grow-0">
          <i (click)="remove($event, notif)" class="grey-text fas fa-circle-xmark mx-3 text-danger fa-lg mt-2" size="lg"></i>
        </div>
      </div>
      <div class="dropdown-divider mb-0" *ngIf="!last"></div>
    </a>
  </div>
</li>
